const PrivacyContent = () => {
  return (
    <section className="privacy-content">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="top-wrapper">
                <h4>
                  Kebijakan Privasi
                </h4>
                <p>
                  Kami menghargai privasi Anda dan berkomitmen untuk melindungi data pribadi yang Anda berikan saat menggunakan website ini. Dokumen ini menjelaskan bagaimana kami mengumpulkan, menggunakan, menyimpan, dan melindungi informasi Anda. Dengan mengakses atau menggunakan layanan kami, Anda dianggap telah menyetujui praktik yang dijelaskan dalam Kebijakan Privasi ini.
                </p>

                <div className="safe-data">
                  <h5>
                    Pengumpulan Informasi
                  </h5>
                  <p>
                    Kami dapat mengumpulkan informasi pribadi dari pengguna ketika:
                  </p>
                  <ul>
                    <li>Mengisi formulir di website</li>
                    <li>Mendaftar akun</li>
                    <li>Menghubungi kami melalui email atau kontak lain</li>
                    <li>Menggunakan layanan atau fitur tertentu di website</li>
                  </ul>
                  <h5>Penggunaan Informasi</h5>
                  <p>Informasi yang dikumpulkan digunakan untuk:</p>
                  <ul>
                    <li>Memberikan layanan dan fitur website</li>
                    <li>Menyediakan dukungan pelanggan</li>
                    <li>Mengirimkan informasi terkait produk, layanan, atau promosi</li>
                    <li>Meningkatkan kualitas dan pengalaman pengguna di website</li>
                  </ul>
                  <h5>Penyimpanan dan Keamanan</h5>

                  <ul>
                    <li>Data disimpan dengan sistem yang wajar untuk mencegah akses tanpa izin</li>
                    <li>Kami berkomitmen menjaga keamanan informasi pribadi pengguna</li>
                  </ul>
                  <h5>Berbagi Informasi dengan Pihak Ketiga</h5>
                  <ul>
                    <li>Tidak menjual atau menyewakan informasi pribadi kepada pihak ketiga</li>
                    <li>Informasi dapat dibagikan jika diminta oleh hukum atau peraturan yang berlaku</li>
                  </ul>
                  <h5>Hak Pengguna</h5>
                  <ul>
                    <li>Mengakses, memperbarui, atau menghapus informasi pribadi</li>
                    <li>Menolak penggunaan data untuk tujuan pemasaran</li>
                    <li>Menghubungi kami untuk permintaan terkait data pribadi</li>
                  </ul>

                  <h5>Perubahan Kebijakan</h5>
                  <ul>
                    <li>Kebijakan Privasi dapat diperbarui dari waktu ke waktu</li>
                    <li>Perubahan akan diumumkan di halaman ini dengan tanggal pembaruan terbaru</li>
                  </ul>


                </div>
                <div className="cookies">
                  <h5>Cookies and tracking</h5>
                  <p>
                    Website kami dapat menggunakan cookies untuk meningkatkan pengalaman pengguna. Pengguna dapat menonaktifkan cookies melalui pengaturan browser, namun beberapa fitur mungkin tidak berfungsi optimal.

                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyContent;
